<template>
  <div>
    <b-sidebar
      id="sidebar-backdrop"
      backdrop
      shadow
      bg-variant="white"
      sidebar-class="sidebar-lg"
      no-header
      right
      :visible="customerEditSidebarActive"
      @change="(val) => $emit('update:customer-edit-sidebar-active', val)"
    >

      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            Editar cliente
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Campos formulario -->
        <validation-observer ref="simpleRules">
          <b-form
            v-if="show"
            class="p-2"
            @submit="onSubmit"
          >
            <validation-provider
              v-slot="{ errors }"
              name="cliente"
              rules="required"
            >
              <b-form-group
                label="Cliente:"
                label-for="input-name"
              >
                <b-form-input
                  id="input-name"
                  v-model="form.nombre"
                  placeholder="Ingresa el nombre del cliente"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="nit"
              rules="required"
            >
              <b-form-group
                label="NIT:"
                label-for="input-nit"
              >
                <b-form-input
                  id="input-nit"
                  v-model="form.nit"
                  placeholder="Ingresa el NIT"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <!-- Lista de precios -->
            <validation-provider
              v-slot="{ errors }"
              name="listap"
              rules="required"
            >
              <b-form-group
                label="Lista de precios:"
                label-for="select-category"
              >
                <b-form-select
                  v-if="priceLists"
                  v-model="form.listap"
                  :options="priceLists"
                  value-field="id"
                  text-field="label"
                  input-id="select-listap"
                  placeholder="Selecciona una lista de precios"
                >
                  <template slot="no-options">
                    Lo siento, no se encontraron listas de precios
                  </template>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <!-- Categoría -->
            <validation-provider
              v-slot="{ errors }"
              name="categoría"
              rules="required"
            >
              <b-form-group
                label="Tipo de cliente:"
                label-for="select-category"
              >
                <b-form-select
                  v-if="customerCategories"
                  v-model="form.tipo"
                  :options="customerCategories"
                  value-field="id"
                  text-field="label"
                  input-id="select-category"
                  placeholder="Selecciona una categoría de cliente"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <!-- Vendedor -->
            <validation-provider
              v-slot="{ errors }"
              name="vendedor"
              rules="required"
            >
              <b-form-group
                label="Vendedor:"
                label-for="select-category"
              >
                <b-form-select
                  v-if="customerVendors"
                  v-model="form.vendor"
                  :options="customerVendors"
                  value-field="id"
                  text-field="label"
                  input-id="select-category"
                  placeholder="Selecciona un vendedor"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <!-- Tipo de pago -->
            <validation-provider
              v-slot="{ errors }"
              name="tipo de pago"
              rules="required"
            >
              <b-form-group
                label="Tipo de pago:"
                label-for="select-payment-type"
              >
                <b-form-select
                  v-if="customerPaymentType"
                  v-model="form.forma_pago"
                  :options="customerPaymentType"
                  input-id="select-payment-type"
                  placeholder="Selecciona un tipo de pago"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <!-- Días crédito -->
            <validation-provider
              v-slot="{ errors }"
              name="días de crédito"
              rules="required"
            >
              <b-form-group
                label="Días de crédito:"
                label-for="select-credit-days"
              >
                <b-form-select
                  v-if="customerCreditDays"
                  v-model="form.dias_credito"
                  :options="customerCreditDays"
                  input-id="select-credit-days"
                  placeholder="Selecciona los días de crédito"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="contacto"
              rules="required"
            >
              <b-form-group
                label="Contacto:"
                label-for="input-contact"
              >
                <b-form-input
                  id="input-contact"
                  v-model="form.contacto"
                  placeholder="Ingresa el nombre del contacto"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <b-form-group
              label="Número de celular:"
              label-for="input-cellphone"
            >
              <cleave
                id="input-cellphone"
                v-model="form.movil"
                class="form-control"
                :raw="false"
                :options="options.cellphoneDelimiter"
                placeholder="Número de celular"
              />
            </b-form-group>

            <b-form-group
              label="Número de teléfono:"
              label-for="input-phone"
            >
              <cleave
                id="input-phone"
                v-model="form.tel"
                class="form-control"
                :raw="false"
                :options="options.cellphoneDelimiter"
                placeholder="Número de teléfono"
              />
            </b-form-group>

            <validation-provider
              v-slot="{ errors }"
              name="correo"
              rules="email"
            >
              <b-form-group
                label="Correo:"
                label-for="input-email"
              >
                <b-form-input
                  id="input-email"
                  v-model="form.email"
                  placeholder="Ingresa el correo"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="correo secundario"
              rules="email"
            >
              <b-form-group
                label="Correo secundario:"
                label-for="input-email2"
              >
                <b-form-input
                  id="input-email2"
                  v-model="form.email2"
                  placeholder="Ingresa el correo secundario"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="dirección"
              rules="max:200"
            >
              <b-form-group
                label="Dirección:"
                label-for="textarea-address"
              >
                <b-form-textarea
                  id="textarea-address"
                  v-model="form.direccion"
                  placeholder="Dirección del cliente (200 caracteres máximo)"
                  rows="3"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-if="departments.length > 0"
              v-slot="{ errors }"
              name="departamento"
              rules="required"
            >
              <b-form-group
                label="Departamento:"
                label-for="select-department"
              >
                <v-select
                  v-model="form.depto"
                  placeholder="Selecciona un departamento"
                  input-id="select-department"
                  :options="departments"
                  :clearable="true"
                  @input="val => setDepartment(val)"
                >
                  <template slot="no-options">
                    Lo siento, no se encontraron departamentos
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="municipio"
              rules="required"
            >
              <b-form-group
                label="Municipio:"
                label-for="select-municipality"
              >
                <v-select
                  v-model="form.muni"
                  placeholder="Selecciona un departamento"
                  input-id="select-municipality"
                  :options="municipalities"
                  :clearable="true"
                >
                  <template slot="no-options">
                    Lo siento, no se encontraron municipios
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <b-form-group
              label="Observaciones:"
            >
              <b-form-textarea
                v-model="form.observaciones"
                placeholder="Comentarios y anotaciones relacionadas con el cliente"
              />
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
            >
              Actualizar
            </b-button>
          </b-form>
        </validation-observer>

      </template>

    </b-sidebar>
  </div>
</template>

<script>
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import { required } from '@/utils/validations/validations'
import guatemala from '@/utils/data/guatemala'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Cleave,
    vSelect,
  },
  model: {
    prop: 'customerEditSidebarActive',
    event: 'update:customer-edit-sidebar-active',
  },
  props: {
    customerEditSidebarActive: {
      type: Boolean,
      required: true,
    },
    customerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      required,

      form: {
        nit: 'CF',
        tipo: '',
        listap: '',
        vendor: '',
        forma_pago: '',
        dias_credito: '',
        nombre: '',
        razon: '',
        cliente: 1,
        direccion: '',
        contacto: '',
        tel: '',
        movil: '',
        email: '',
        email2: '',
        pais: 'GUATEMALA',
        depto: '',
        muni: '',
        observaciones: '',
      },
      show: true,
      options: {
        cellphoneDelimiter: {
          delimiters: ['-'],
          blocks: [4, 4],
          uppercase: true,
        },
      },
      customerCategories: [],
      departments: [],
      municipalities: [],
      priceLists: [],
      customerVendors: [],
      customerPaymentType: [
        { value: 'CONTADO', text: 'CONTADO' },
        { value: 'CREDITO', text: 'CREDITO' },
      ],
      customerCreditDays: [
        { value: '8', text: '8' },
        { value: '15', text: '15' },
        { value: '30', text: '30' },
        { value: '45', text: '45' },
        { value: '60', text: '60' },
      ],
    }
  },

  watch: {
    customerEditSidebarActive(val) {
      if (val) {
        this.getCustomer()
      }
    },
  },

  created() {
    this.getCustomer()
    this.getPriceLists()
    this.getCustomerCategories()
    this.getDepartments()
    this.getCustomerVendors()
  },

  methods: {
    getCustomer() {
      axios
        .get(`accounting-system/entities/${this.customerId}`)
        .then(response => {
          this.form.nit = response.data.data.nit
          this.form.tipo = response.data.data.tipo
          this.form.listap = response.data.data.listap
          this.form.vendor = response.data.data.idvendedor
          this.form.forma_pago = response.data.data.forma_pago
          this.form.dias_credito = response.data.data.dias_credito
          this.form.nombre = response.data.data.nombre
          this.form.razon = response.data.data.razon
          this.form.client = response.data.data.client
          this.form.direccion = response.data.data.direccion
          this.form.contacto = response.data.data.contacto
          this.form.tel = response.data.data.tel
          this.form.movil = response.data.data.movil
          this.form.email = response.data.data.email
          this.form.email2 = response.data.data.email2
          this.form.pais = response.data.data.pais
          this.form.depto = response.data.data.depto
          this.form.muni = response.data.data.muni
          this.form.observaciones = response.data.data.observaciones
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    onSubmit(event) {
      event.preventDefault()
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          axios
            .put(`accounting-system/entities/${this.customerId}`, this.form)
            .then(response => {
              this.makeToast('success', 'Cliente actualizado', `Se actualizó el cliente a: ${response.data.data.nombre}.`)
              this.clearForm()
              this.$emit('update:customer-edit-sidebar-active', false)
              this.$emit('refreshData')
            })
            .catch(error => {
              this.showErrors(error)
            })
        } else {
          this.makeToast('danger', 'Error', 'No es posible actualizar el cliente.')
        }
      })
    },

    getCustomerCategories() {
      axios
        .get('accounting-system/entities-categories')
        .then(response => {
          response.data.data.forEach(element => {
            this.customerCategories.push({
              id: element.identidades_tipos,
              label: element.descrip,
            })
          })
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    getCustomerVendors() {
      const filterArray = [
        { field: 'role', value: 'vendor' },
      ]

      axios
        .get(`vendors?filters=${JSON.stringify(filterArray)}`)
        .then(response => {
          response.data.data.forEach(element => {
            this.customerVendors.push({
              id: element.id,
              label: element.name,
            })
          })
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    getPriceLists() {
      axios
        .get('accounting-system/product-price-list')
        .then(response => {
          response.data.data.forEach(element => {
            this.priceLists.push({
              id: element.listap,
              label: element.descrip,
            })
          })
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    getDepartments() {
      this.departments = []
      Object.keys(guatemala).forEach(element => {
        this.departments.push({
          value: element,
          label: element,
        })
      })
    },

    setDepartment(dept) {
      this.municipalities = []
      if (dept) {
        this.form.depto = dept.value
        this.municipalities = guatemala[dept.value]
      }
    },

    clearForm() {
      // Reset our form values
      this.form.nit = 'CF'
      this.form.tipo = ''
      this.form.listap = ''
      this.form.vendor = ''
      this.form.forma_pago = ''
      this.form.dias_credito = ''
      this.form.nombre = ''
      this.form.razon = ''
      this.form.cliente = 1
      this.form.direccion = ''
      this.form.contacto = ''
      this.form.tel = ''
      this.form.movil = ''
      this.form.email = ''
      this.form.email2 = ''
      this.form.pais = ''
      this.form.depto = ''
      this.form.muni = ''
      this.form.observaciones = ''

      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>
